/** @format */

import template from './gb-add-honour-roll-widget.html';
import _ from 'lodash';

export const GbAddHonourRollWidgetComponent = {
    template,
    require: {
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddHonourRollWidgetComponent {
        constructor($gbHonourRollProjectorWidget, $translate, $mdColors) {
            'ngInject';

            this.$gbHonourRollProjectorWidget = $gbHonourRollProjectorWidget;
            this.$translate = $translate;
            this.$mdColors = $mdColors;

            this.honourRollWidgetDefaults = {
                columns: 1,
                rows: 5,
                slide_interval: 10,
                x: 10,
                y: 10,
                x_unit: '%',
                y_unit: '%',
                width: 80,
                width_unit: '%',
                height: 80,
                height_unit: '%',
                opacity: 1,
                font_size: 10,
            };

            this.defaultTableColors = {
                table_primary_color: this.$mdColors.getThemeColor('default-primary'),
                table_accent_color: this.$mdColors.getThemeColor('default-accent'),
                table_background_color: this.$mdColors.getThemeColor('default-background'),
            };
        }

        getWidget() {
            return this.widget;
        }

        addWidget() {
            let widget = new this.$gbHonourRollProjectorWidget(this.honourRollWidgetDefaults);
            _.assign(widget, this.defaultTableColors);

            this.gbPresenter.tempWidgets.push(widget);
        }
    },
};
